import { Navigate, useLocation } from "react-router-dom";
import { useAppSelector } from "@app/redux/hooks";

const ProtectedRoute = ({
  component: Component,
  render = null,
  adminRequired = false,
  ...rest
}) => {

  const user = useAppSelector((state) => state.user.user);
  const {pathname}  = useLocation()

  if (user != null) {
    if (adminRequired && !user.admin) {
      return <Navigate to="/403" />
    }
    return Component ? <Component {...rest} /> : render(rest);
  }
  return (
    <Navigate to="/login" state={{from: pathname}} />
  );
};

export function AnonymousRoute ({
  component: Component,
  render = null,
  adminRequired = false,
  ...rest
}) {

  const user = useAppSelector((state) => state.user.user);
  const {pathname}  = useLocation()

  if (user == null) {
    return Component ? <Component {...rest} /> : render(rest);
  }
  return (
    <Navigate to="/" state={{from: pathname}} />
  );
};

export default ProtectedRoute;